var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPausedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 420,
    viewBox: "0 0 421 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 210.5,
    cy: 207,
    r: 160,
    stroke: "#D5BB43",
    strokeWidth: 11
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_938_1561)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.5 366C298.866 366 370.5 294.366 370.5 206C370.5 117.634 298.866 46 210.5 46C122.134 46 50.5 117.634 50.5 206C50.5 294.366 122.134 366 210.5 366ZM210.5 339.333C284.138 339.333 343.833 279.638 343.833 206C343.833 132.362 284.138 72.6667 210.5 72.6667C136.862 72.6667 77.1667 132.362 77.1667 206C77.1667 279.638 136.862 339.333 210.5 339.333Z",
    fill: "#FFCB00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.5 366C298.866 366 370.5 294.366 370.5 206C370.5 117.634 298.866 46 210.5 46C122.134 46 50.5 117.634 50.5 206C50.5 294.366 122.134 366 210.5 366ZM210.5 339.333C284.138 339.333 343.833 279.638 343.833 206C343.833 132.362 284.138 72.6667 210.5 72.6667C136.862 72.6667 77.1667 132.362 77.1667 206C77.1667 279.638 136.862 339.333 210.5 339.333Z",
    fill: "url(#paint0_linear_938_1561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.167 152.667C187.167 141.621 178.212 132.667 167.167 132.667C156.121 132.667 147.167 141.621 147.167 152.667V259.333C147.167 270.379 156.121 279.333 167.167 279.333C178.212 279.333 187.167 270.379 187.167 259.333V152.667Z",
    fill: "#FFCB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.167 152.667C187.167 141.621 178.212 132.667 167.167 132.667C156.121 132.667 147.167 141.621 147.167 152.667V259.333C147.167 270.379 156.121 279.333 167.167 279.333C178.212 279.333 187.167 270.379 187.167 259.333V152.667Z",
    fill: "url(#paint1_linear_938_1561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.5 152.667C270.5 141.621 261.546 132.667 250.5 132.667C239.454 132.667 230.5 141.621 230.5 152.667V259.333C230.5 270.379 239.454 279.333 250.5 279.333C261.546 279.333 270.5 270.379 270.5 259.333V152.667Z",
    fill: "#FFCB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.5 152.667C270.5 141.621 261.546 132.667 250.5 132.667C239.454 132.667 230.5 141.621 230.5 152.667V259.333C230.5 270.379 239.454 279.333 250.5 279.333C261.546 279.333 270.5 270.379 270.5 259.333V152.667Z",
    fill: "url(#paint2_linear_938_1561)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_938_1561",
    x: 0.5,
    y: 0,
    width: 420,
    height: 420,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_938_1561"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_938_1561",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_938_1561",
    x1: 370.5,
    y1: 232,
    x2: 73,
    y2: 142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5BB43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FFEB8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5BB43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_938_1561",
    x1: 370.5,
    y1: 232,
    x2: 73,
    y2: 142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5BB43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FFEB8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5BB43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_938_1561",
    x1: 370.5,
    y1: 232,
    x2: 73,
    y2: 142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5BB43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FFEB8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5BB43"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPausedIcon);
export default __webpack_public_path__ + "static/media/paused_icon.7e132757a79d72c314e4fd5f46d78b95.svg";
export { ForwardRef as ReactComponent };